// extracted by mini-css-extract-plugin
module.exports = {"conteiner_loading":"loading_conteiner_loading__1_H80","click_here":"loading_click_here__2QOvj"};